var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotequalsOutline16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58663 2.53148C4.32787 2.20803 3.8559 2.15559 3.53246 2.41435C3.20901 2.6731 3.15657 3.14507 3.41532 3.46852L4.64051 5H2.74609C2.33188 5 1.99609 5.33578 1.99609 5.75C1.99609 6.16421 2.33188 6.5 2.74609 6.5H5.84051L8.24051 9.5H2.74609C2.33188 9.5 1.99609 9.83578 1.99609 10.25C1.99609 10.6642 2.33188 11 2.74609 11H9.44051L11.4153 13.4685C11.6741 13.792 12.1461 13.8444 12.4695 13.5856C12.7929 13.3269 12.8454 12.8549 12.5866 12.5315L11.3614 11H13.2515C13.6657 11 14.0015 10.6642 14.0015 10.25C14.0015 9.83578 13.6657 9.5 13.2515 9.5H10.1614L7.76145 6.5H13.2515C13.6657 6.5 14.0015 6.16421 14.0015 5.75C14.0015 5.33578 13.6657 5 13.2515 5H6.56145L4.58663 2.53148Z",
    fill: "#7B868C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotequalsOutline16);
export default __webpack_public_path__ + "static/media/notequals_outline_16.6c276f7c34a450d50a39f999da3604b4.svg";
export { ForwardRef as ReactComponent };